export const CLINIC_OS_ASSET_BASE = "https://clinic-os.com/user-app-assets/";
export const R2_ASSET_BASE =
  "https://pub-0991182fdab143cf938953a8d6ab8813.r2.dev/user-app-assets/";

export const STICKER_PRESETS = [
  {
    id: "wow",
    label: "Wow",
    filename: "wow.png",
    url: `${R2_ASSET_BASE}stickers/wow.png`,
  },
  {
    id: "stay-weird",
    label: "Stay weird",
    filename: "stayweird.png",
    url: `${R2_ASSET_BASE}stickers/stayweird.png`,
  },
  {
    id: "lets-go",
    label: "Let's go",
    filename: "letsgo.png",
    url: `${R2_ASSET_BASE}stickers/Letsgo.png`,
  },
] as const;

export type TStickerPreset = (typeof STICKER_PRESETS)[number];
export type TStickerPresetId = TStickerPreset["id"];

export const DEFAULT_STICKER_PRESET = STICKER_PRESETS[0];
export const DEFAULT_CENSORSHIP_STICKER_URL = DEFAULT_STICKER_PRESET.url;
export const STICKER_PRESET_URLS = STICKER_PRESETS.map((preset) => preset.url);
export const CANONICAL_STICKER_URLS: Readonly<Record<string, string>> =
  Object.fromEntries(
    STICKER_PRESETS.map((preset) => [preset.filename, preset.url]),
  );

export const toCanonicalStickerSrc = (src?: string) => {
  if (!src) return src;
  const normalizedSrc = src.toLowerCase();

  for (const [stickerName, canonicalUrl] of Object.entries(
    CANONICAL_STICKER_URLS,
  )) {
    if (normalizedSrc.includes(`/stickers/${stickerName}`)) {
      return canonicalUrl;
    }
  }

  if (src.startsWith(CLINIC_OS_ASSET_BASE)) {
    return src.replace(CLINIC_OS_ASSET_BASE, R2_ASSET_BASE);
  }

  return src;
};
